<template>
    <v-card
        :height="$vuetify.breakpoint.mdAndUp ? '480' : ''"
        :ripple="false"
        :elevation="elevation"
        class="pa-4"
        @click="setFormType(2)"
    >
        <v-radio-group
            v-if="$vuetify.breakpoint.mdAndUp"
            v-model="formType"
            :hide-details="true"
            class="mt-0"
            dense
        >
            <v-radio value="2">
                <template v-slot:label>
                    <span style="font-size:20px;color:#444444"
                        ><TranslatableStringComponent :tstring="{string: 'copyAndPaste'}" /></span
                    >
                </template>
            </v-radio>
        </v-radio-group>

        <v-card-subtitle class="px-0"
            ><TranslatableStringComponent :tstring="{string: 'bulkOrderCopyPasteNote'}" />
        </v-card-subtitle>
        <v-card-text class="px-0"
            ><TranslatableStringComponent :tstring="{string: 'partNumber'}" /> #1, <TranslatableStringComponent :tstring="{string: 'qty'}" /> <br />
            <TranslatableStringComponent :tstring="{string: 'partNumber'}" /> #2, <TranslatableStringComponent :tstring="{string: 'qty'}" /></v-card-text
        >
        <div class="pa-0">
            <ValidationProvider
                :rules="`${formType === '2' ? 'required|copyPasteFormat' : ''}`"
            >
                <div slot-scope="{ errors }" style="position:relative">
                    <span class="validationMessage">
                        {{ errors[0] }}
                    </span>
                    <v-textarea
                        v-model="textAreaValues"
                        class=""
                        outlined
                        :label="`${localize('partNumber')} & ${localize('qty')}`"
                        :placeholder="placeholder"
                    ></v-textarea>
                </div>
            </ValidationProvider>
        </div>
    </v-card>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import handleSnackbar from '~/mixins/handleSnackbar'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

const { mapFields } = createHelpers({
    getterType: 'getBulkOrderPadField',
    mutationType: 'updateBulkOrderPadField'
})
export default {
    name: 'BulkOrderPadCopyPaste',
    components: {
        ValidationProvider,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    data() {
        return {
            placeholder: 'D16A211,8 \nDRMR3D,15 \nHSSO2-SLGY-LRNO,50',
            isLoading: false,
            e1: 1
        }
    },
    computed: {
        ...mapFields('bulkOrderPad', ['textAreaValues', 'formType']),
        ...mapGetters({
            selectedPns: 'bulkOrderPad/selectedPns'
        }),
        elevation() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return this.formType === 2 ? 10 : 2
            } else {
                return 0
            }
        }
    },
    methods: {
        setFormType(type) {
            if (type === 1) {
                this.formType = '1'
            } else {
                this.formType = '2'
            }
        }
    }
}
</script>

<style></style>
